import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const DownIcon: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 24 24'
  >
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M6 9l6 6 6-6'
    />
  </svg>
)

export default DownIcon;
